module.exports = __webpack_public_path__ + "img/icon_chat_en.ea0ffa7b.webp";